import React from 'react';

interface Props {
  value: string;
  label: string;
}

const PerformanceBadge: React.FC<Props> = ({ value, label }) => (
  <div className="badge-base">
    <div className="badge-text">
      <span className={`disclosure ${value}`}>{label}</span>
    </div>
  </div>
);

export default React.memo(PerformanceBadge);
